module.exports = __webpack_public_path__ + "static/media/foundationAnalytics.3872d825.svg";